module.exports = __webpack_public_path__ + "f39d51f362c16274c6d322663120c7c2.png";